<template>
  <div class="input-group">
    <toggle-button
      @change="change(field)"
      :value="model[field]"
      :sync="true"
      color="#009AB1"
      :labels="{checked, unchecked}"
      :width="72"
      :height="30"
    />
    <small v-if="inputHint" class="form-text text-muted">{{ inputHint }}</small>
    <small v-for="error in validationErrors" :key="error" class="form-text text-danger">{{ error }}</small>
  </div>
</template>

<script>
import inputHelpers from './input-helpers'

export default {
  mixins: [inputHelpers],
  props: {
    checked: {
      type: String,
      default: 'True'
    },
    unchecked: {
      type: String,
      default: 'False'
    }
  },
  methods: {
    change (field) {
      this.model[field] = !this.model[field]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/fractel/components/vue-mc/form/mc-switch.vue